import * as s from '@ember/service';

export default s.service ?? s.inject;
